import Vue from 'vue';
import Vuex from 'vuex';

// modules
import params from './modules/params';
import account from './modules/account';
import application from './modules/application';
import audience from './modules/audience';
import user from './modules/user';
import users from './modules/users';
import trip from './modules/trip';
import firehose from './modules/firehose';
import webhook from './modules/webhook';
import api_key from './modules/api_key';

Vue.use(Vuex);

const state = {};

const mutations = {};

const getters = {};

let store = new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {
    params,
    account,
    application,
    audience,
    user,
    users,
    trip,
    firehose,
    webhook,
    api_key,
  },
});

export default store;
